module.exports = __webpack_public_path__ + "static/img/wireless-bg.ed796e5d.png";